module.exports = __webpack_public_path__ + "img/00039.5a7b9891.webp";